module.exports = "/images/sl.svg";